import { render, staticRenderFns } from "./StandortLieferung.vue?vue&type=template&id=93f81fe0"
import script from "./StandortLieferung.vue?vue&type=script&lang=ts"
export * from "./StandortLieferung.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports